import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FilterStateShape from './../DashboardFilters.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { forIn, toPairs, without, isEqual } from 'lodash';
import { ENTITIES_FILTER_ALL_ENTITIES, ENTITIES_FILTER_SPECIFIC, ENTITIES_FILTER_CATEGORIES } from "../../../../../constants";
import { defaults } from './../DashboardFilters';

class NarrowByFilter extends Component {
    static propTypes = {
        filtersState: PropTypes.shape({
            filters: PropTypes.shape(FilterStateShape)
        }).isRequired,
        categories: PropTypes.object,
        entities: PropTypes.object,
        changeHandlers: PropTypes.object,
        readOnly: PropTypes.bool
    }

    static defaultProps = {
        readOnly: false
    }

    constructor(props) {
        super(props);
        this.setFiltersOrder(props);
    }

    setFiltersOrder(props) {
        this.filterOrder = [];
        if (props.filtersState.filters.entities) {
            this.filterOrder.push(this.filters.entities)
        }
        if (props.filtersState.filters.pestle) {
            this.filterOrder.push(this.filters.pestle)
        }
        if (props.filtersState.filters.risk) {
            this.filterOrder.push(this.filters.risk)
        }
        if (props.filtersState.filters.days) {
            this.filterOrder.push(this.filters.days)
        }
        if (props.filtersState.filters.language) {
            this.filterOrder.push(this.filters.language)
        }
    }

    filters = {
        risk: {
            uncheckAction: (riskLevel) => {
                let newRiskFilter = this.props.filtersState.filters.risk
                newRiskFilter[riskLevel] = false
                this.props.changeHandlers.risk(newRiskFilter)
            },
            areAllSelected: () => {
                let allSelected = true;
                forIn(this.props.filtersState.filters.risk, (value) => { !value && (allSelected = false)} )
                return allSelected;
            },
            toDefault: () => {
                this.props.changeHandlers.risk(defaults.risk)
            },
            general: () => {
                if (this.filters.risk.areAllSelected()) {
                    return <FilterItem readOnly={this.props.readOnly} key="all_risk" closeHandler={this.filters.risk.toDefault}>
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.selectOptionsRisk.allRiskLevels"/>
                    </FilterItem>
                }
            },
            individual: () => {
                if (!this.filters.risk.areAllSelected()) {
                    return toPairs(this.props.filtersState.filters.risk).filter(item => item[1]).map(risk => {
                        let closeHandler = (e) => this.filters.risk.uncheckAction(risk[0])
                        if (isEqual(this.props.filtersState.filters.risk, defaults.risk)) {
                            closeHandler = null
                        }
                        return (
                            <FilterItem readOnly={this.props.readOnly} key={risk[0]} closeHandler={closeHandler}>
                                <FormattedMessage id={`Dashboard_CoreFunctionality_UIText_dashboard.${risk[0]}RiskLevel`}/>
                            </FilterItem>
                        )
                    })
                }
            }
        },
        entities: {
            uncheckAction: (item) => {
                let newEntitiesFilter = Object.assign({}, this.props.filtersState.filters.entities)
                let newCategories = Object.assign({}, newEntitiesFilter.categories)
                switch (item) {
                    case "allCategories": {
                        newCategories.allCategories = false

                        if (!newCategories.allUnassigned) {
                            newEntitiesFilter.type = ENTITIES_FILTER_ALL_ENTITIES
                        }
                        break;
                    }
                    case "allUnassigned": {
                        newCategories.allUnassigned = false

                        if (!this.props.filtersState.filters.entities.categories.categoriesId.length) {
                            if (!newCategories.allCategories) {
                                newEntitiesFilter.type = ENTITIES_FILTER_ALL_ENTITIES
                            }
                        }
                        break;
                    }
                    default: {
                        newEntitiesFilter.entitiesId = without(newEntitiesFilter.entitiesId, item)
                        if (newEntitiesFilter.entitiesId.length === 0) {
                            newCategories.allCategories = true;
                            newCategories.allUnassigned = true;
                        }
                        break;
                    }
                }
                this.props.changeHandlers.entities({ type: newEntitiesFilter.type, categories: newCategories, entitiesId: newEntitiesFilter.entitiesId })
            },
            uncheckCategoryAction: (item) => {
                let categoryItems = Object.assign({}, this.props.filtersState.filters.entities.categories)

                categoryItems.categoriesId = without(categoryItems.categoriesId, item)
                if (categoryItems.categoriesId.length === 0 && !categoryItems.allUnassigned) {
                    categoryItems.allCategories = true;
                    categoryItems.allUnassigned = true;
                }
                this.props.changeHandlers.entities({ categories: Object.assign({}, categoryItems) })
            },
            general: () => {
                if (this.props.filtersState.filters.entities.type === ENTITIES_FILTER_ALL_ENTITIES) {
                    return <FilterItem readOnly={this.props.readOnly} key={ENTITIES_FILTER_ALL_ENTITIES}>
                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll"/>
                    </FilterItem>
                }
            },
            individual: () => {
                if (this.props.categories) {
                    switch (this.props.filtersState.filters.entities.type) {
                        case ENTITIES_FILTER_CATEGORIES: {
                            let categoryItems = this.props.filtersState.filters.entities.categories.categoriesId.map(category =>
                                <FilterItem key={category}
                                            readOnly={this.props.readOnly}
                                            closeHandler={(e) => this.filters.entities.uncheckCategoryAction(category)}>
                                    {this.props.categories[category]}
                                </FilterItem>
                            )
                            if (this.props.filtersState.filters.entities.categories.allCategories) {
                                categoryItems.push(<FilterItem key={"allCategories"}
                                                               readOnly={this.props.readOnly}
                                                               closeHandler={(e) => this.filters.entities.uncheckAction("allCategories")}>
                                    <FormattedMessage id="Dashboard_Charts_UIText_dashboard.filters.allAssigned"/>
                                </FilterItem>)
                            }
                            if (this.props.filtersState.filters.entities.categories.allUnassigned) {
                                categoryItems.push(<FilterItem key={"allUnassigned"}
                                                               readOnly={this.props.readOnly}
                                                               closeHandler={(e) => this.filters.entities.uncheckAction("allUnassigned")}>
                                    <FormattedMessage id="Dashboard_Charts_UIText_dashboard.filters.allUnassigned"/>
                                </FilterItem>)
                            }
                            return categoryItems
                        }
                        case ENTITIES_FILTER_SPECIFIC: {
                            if (this.props.filtersState.filters.entities.entitiesId.length) {
                                let entityItems = this.props.filtersState.filters.entities.entitiesId.map(entity =>
                                    this.props.entities ?
                                        (<FilterItem key={entity}
                                                     readOnly={this.props.readOnly}
                                                     closeHandler={(e) => this.filters.entities.uncheckAction(entity)}>
                                            {this.props.entities[entity]}
                                        </FilterItem>)
                                        : null
                                )
                                return entityItems
                            } else {
                                return <FilterItem key={ENTITIES_FILTER_ALL_ENTITIES} readOnly={this.props.readOnly}>
                                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll"/>
                                </FilterItem>
                            }
                        }
                        case ENTITIES_FILTER_ALL_ENTITIES: {
                            // this is handled in general function above
                            break;
                        }
                    }
                }
            }
        },
        pestle: {
            uncheckAction: (pestle) => {
                let newPestleFilter = this.props.filtersState.filters.pestle
                newPestleFilter[pestle] = false
                this.props.changeHandlers.pestle(newPestleFilter)
            },
            areAllSelected: () => {
                let allSelected = true;
                forIn(this.props.filtersState.filters.pestle, (value) => { !value && (allSelected = false)} )
                return allSelected;
            },
            general: () => {
                if (this.filters.pestle.areAllSelected()) {
                    return <FilterItem readOnly={this.props.readOnly} key="all_pestle">
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.selectOptionsPestle.allRiskAngles"/>
                    </FilterItem>
                }
            },
            individual: () => {
                if (!this.filters.pestle.areAllSelected()) {
                    return toPairs(this.props.filtersState.filters.pestle).filter(item => item[1]).map(pestle =>
                        <FilterItem readOnly={this.props.readOnly} key={pestle[0]} closeHandler={(e) => this.filters.pestle.uncheckAction(pestle[0])}>
                            <FormattedMessage id={"General_CoreFunctionality_UIText_general." + pestle[0]}/>
                        </FilterItem>
                    )
                }
            }
        },
        days: {
            toDefault: () => {
                this.props.changeHandlers.days(defaults.days)
            },
            general: () => {
                return null
            },
            individual: () => {
                let closeHandler = (e) => this.filters.days.toDefault()
                if (isEqual(this.props.filtersState.filters.days, defaults.days)) {
                    closeHandler = null
                }
                return (<FilterItem readOnly={this.props.readOnly} key={"dateFilter"} closeHandler={closeHandler}>
                    <FormattedMessage id={dayLabels[this.props.filtersState.filters.days]} />
                </FilterItem>);
            }
        },
        language: {
            uncheckAction: (language) => {
                let languageLanguageFilter = this.props.filtersState.filters.language
                languageLanguageFilter[language] = false
                this.props.changeHandlers.language(languageLanguageFilter)
            },
            areAllSelected: () => {
                let allSelected = true;
                forIn(this.props.filtersState.filters.language, (value) => { !value && (allSelected = false)} )
                return allSelected;
            },
            toDefault: () => {
                this.props.changeHandlers.language(defaults.language)
            },
            general: () => {
                if (this.filters.language.areAllSelected()) {
                    return <FilterItem key="all_languages">
                        <FormattedMessage id="General_CoreFunctionality_UIText_languageSelect.allLanguages"/>
                    </FilterItem>
                }
            },
            individual: () => {
                if (!this.filters.language.areAllSelected()) {
                    return toPairs(this.props.filtersState.filters.language).filter(item => item[1]).map(language => {
                        let closeHandler = (e) => this.filters.language.uncheckAction(language[0])
                        if (isEqual(this.props.filtersState.filters.language, defaults.language)) {
                            closeHandler = null
                        }
                        return (
                            <FilterItem readOnly={this.props.readOnly} key={"filter_item_" + language[0]} closeHandler={closeHandler}>
                                <FormattedMessage id={`Dashboard_Charts_UIText_dashboard.filters.language.${language[0]}`}/>
                            </FilterItem>
                        )
                    })
                }
            }
        },
    }

    renderGeneral() {
        return this.filterOrder.map(filter => {
            return filter.general()
        })
    }

    renderIndividual() {
        return this.filterOrder.map(filter => {
            return filter.individual()
        })
    }

    renderGrouped() {
        return this.filterOrder.map((filter, key) => {
            return <div className={"filter-" + key} key={key}> {filter.individual()} {filter.general()} </div>
        })
    }

    render() {
        return (
            <div className="narrow-by">
                {this.renderGrouped()}
            </div>
        )
    }
}

export default injectIntl(NarrowByFilter);
export { NarrowByFilter };

class FilterItem extends Component {
    static propTypes = {
        closeHandler: PropTypes.func,
        readOnly: PropTypes.bool
    }

    static defaultProps = {
        closeHandler: null,
        readOnly: false
    }

    render() {
        return (
            <div className="filter-item" title={typeof(this.props.children) !== 'object' ? this.props.children : this.props.intl.formatMessage({id: this.props.children.props.id})}>
                {this.props.children}
                {this.props.closeHandler && !this.props.readOnly && (<div className="remove-filter" onClick={this.props.closeHandler}>X</div>)}
            </div>
        )
    }
}
FilterItem = injectIntl(FilterItem);
export { FilterItem };

const dayLabels = {
    1: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastDay',
    7: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastWeek',
    30: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastMonth'
}


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/NarrowBy.filter.jsx